import { message, Modal, Upload, UploadProps } from 'antd';
import styled from '@emotion/styled';
import { UploadOutlined } from '@ant-design/icons';
import { useAuthorization } from 'components/Authorization';
import useModal from 'hooks/useModal';
import { UploadFile } from 'antd/es/upload/interface';
import { useTranslate } from '@tolgee/react';

const Image = styled.img`
  width: 472px;
  margin-top: 15px;
`;

export interface ImageUploaderProps extends UploadProps {
  limitCount?: number;
}

function ImageUploader(props: ImageUploaderProps) {
  const { fileList = [], limitCount = 1, ...otherProps } = props;

  const { t } = useTranslate();

  const { token } = useAuthorization();

  const { visible, show, hide, meta } = useModal<UploadFile>();

  return (
    <>
      <Upload
        listType="picture-card"
        headers={{
          [import.meta.env.VITE_AUTH_HEADER as string]: `Bearer ${token}`,
        }}
        action={`${import.meta.env.VITE_LEYANBOT_HOST}/overseaim-store-home/v1/upload_image`}
        accept=".jpg,.jpeg,.png"
        beforeUpload={(file) => {
          const uploadSizeLimit = 3 * 1024 * 1024;

          if (file.size > uploadSizeLimit) {
            message.warn(
              t('phrase.超出图片限制xM大小', { x: (uploadSizeLimit / 1024 / 1024).toFixed(2) }),
            );

            return Upload.LIST_IGNORE;
          }

          return Promise.resolve();
        }}
        onPreview={show}
        fileList={fileList}
        {...otherProps}
      >
        {fileList.length < limitCount && (
          <div>
            <UploadOutlined />
            <div>{t('phrase.上传图片')}</div>
          </div>
        )}
      </Upload>
      <Modal visible={visible} onCancel={() => hide()} title={null} footer={null}>
        {meta ? <Image alt={meta.name} src={meta.url} /> : null}
      </Modal>
    </>
  );
}

export default ImageUploader;
